"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useQuickBetForm = void 0;
const react_redux_1 = require("react-redux");
const CommonDataProvider_1 = require("astra-core/containers/CommonDataProvider");
const react_1 = require("react");
const useValidateQuickBetValue_1 = require("./useValidateQuickBetValue");
const basket_quick_bet_utils_1 = require("../basket-quick-bet.utils");
const selectors_1 = require("astra-core/containers/SettingsProvider/selectors");
const utils_1 = require("astra-core/utils");
const useQuickBetForm = () => {
    const minBet = (0, react_redux_1.useSelector)((state) => (0, CommonDataProvider_1.selectCurrencyMinBet)(state));
    const [inputValue, setInputValue] = (0, react_1.useState)(String(minBet));
    const quickBetAmount = (0, react_redux_1.useSelector)((state) => (0, selectors_1.selectSettingsDataProp)(state, 'quickBetAmount'));
    (0, react_1.useEffect)(() => {
        const value = quickBetAmount !== undefined
            ? (0, utils_1.adjustAmountForFrontend)(quickBetAmount)
            : minBet;
        setInputValue(String(value));
    }, [minBet, quickBetAmount]);
    const error = (0, useValidateQuickBetValue_1.useValidateQuickBetValue)((0, basket_quick_bet_utils_1.formatString)(inputValue !== null && inputValue !== void 0 ? inputValue : '0'));
    const handleChangeInput = (0, react_1.useCallback)((value) => {
        setInputValue(value !== null && value !== void 0 ? value : '');
    }, []);
    const handleSelectAmount = (0, react_1.useCallback)((value) => {
        setInputValue(value);
    }, []);
    return (0, react_1.useMemo)(() => ({
        inputValue,
        error,
        handleChangeInput,
        handleSelectAmount,
    }), [inputValue, error, handleChangeInput, handleSelectAmount]);
};
exports.useQuickBetForm = useQuickBetForm;
//# sourceMappingURL=useQuickBetForm.js.map